import {Component, OnInit, ChangeDetectionStrategy, inject, OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { StatisticsStateService, StatisticsFilters } from '../../features/statistics/controller/statistics-state.service';
import { StatisticsFilterPayload, StatisticsFilterBarComponent } from '../../features/statistics/view/statistics-filter-bar/statistics-filter-bar.component';
import { StatisticsTabsComponent } from '../../features/statistics/view/statistics-tabs/statistics-tabs.component';
import { StatsAiModeToggleComponent } from '../../features/statistics-ai/view/stats-ai-mode-toggle/stats-ai-mode-toggle.component';
import {Router} from "@angular/router";


@Component({
  selector: 'app-statistics-search-page',
  templateUrl: './statistics-search-page.component.html',
  styleUrls: ['./statistics-search-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatProgressSpinner,
    StatisticsFilterBarComponent,
    StatisticsTabsComponent,
    StatsAiModeToggleComponent
  ]
})
export class StatisticsSearchPageComponent implements OnInit, OnDestroy {

  private state = inject(StatisticsStateService);
  private router = inject(Router);

  public filters$: Observable<StatisticsFilters | null>;
  public isLoadingFilters$: Observable<boolean>;

  public selectedTabIndex = 0;
  public restoredFilters: StatisticsFilterPayload | null = null;
  public statsMode: 'actas' | 'ia' = 'actas';

  constructor() {
    this.filters$ = this.state.filters$;
    this.isLoadingFilters$ = this.state.isLoadingFilters$;

    // --- LÓGICA DE RESTAURACIÓN ---
    const nav = this.router.getCurrentNavigation();

    // Verificamos si venimos con la intención de restaurar (desde un detalle)
    if (nav?.extras.state && nav.extras.state['restoreSearch']) {

      // Recuperar Modo e Índice
      this.selectedTabIndex = this.state.getSnapshotTabIndex();
      this.statsMode = this.state.getSnapshotStatsMode();
      this.state.setStatsMode(this.statsMode);
      this.state.setActiveTab(this.selectedTabIndex);

      // Recuperar Filtros según la tab
      switch (this.selectedTabIndex) {
        case 0: this.restoredFilters = this.state.getTeamFiltersSnapshot(); break;
        case 1: this.restoredFilters = this.state.getMatchFiltersSnapshot(); break;
        case 2: this.restoredFilters = this.state.getPlayerFiltersSnapshot(); break;
      }

    } else {
      // Si entramos de cero (ej. desde Navbar), limpiamos todo
      this.state.clearSearchSnapshot();
      this.state.resetState();
      this.selectedTabIndex = 0;
    }
  }

  ngOnInit(): void {
    // Carga los filtros (Seasons, Comps, etc.)
    this.state.loadInitialFilters();
  }

  ngOnDestroy(): void {
    // Persistir explícitamente filtros activos (incluido textSearch) antes de salir.
    const currentFilters = this.state.getCurrentFiltersSnapshot();
    if (!currentFilters) return;

    this.state.setSnapshotTabIndex(this.selectedTabIndex);
    this.state.setSnapshotStatsMode(this.statsMode);

    switch (this.selectedTabIndex) {
      case 0: this.state.setTeamFiltersSnapshot(currentFilters); break;
      case 1: this.state.setMatchFiltersSnapshot(currentFilters); break;
      case 2: this.state.setPlayerFiltersSnapshot(currentFilters); break;
    }
  }

  /**
   * Recibe el evento de la barra de filtros y lo pasa al estado
   */
  public onFiltersChanged(payload: StatisticsFilterPayload): void {
    this.state.setFilters(payload);

    const currentTab = this.state.getSnapshotTabIndex();
    switch (currentTab) {
      case 0: this.state.setTeamFiltersSnapshot(payload); break;
      case 1: this.state.setMatchFiltersSnapshot(payload); break;
      case 2: this.state.setPlayerFiltersSnapshot(payload); break;
    }
  }

  /**
   *  Recibe el cambio de pestaña y lo pasa al estado
   */
  public onTabChanged(tabIndex: number): void {
    this.selectedTabIndex = tabIndex;
    this.state.setActiveTab(tabIndex);
    this.state.setSnapshotTabIndex(tabIndex);
  }

  public onModeChange(newMode: 'actas' | 'ia'): void {
    this.statsMode = newMode;
    this.state.setStatsMode(newMode);
    this.state.setSnapshotStatsMode(newMode);
    if (newMode === 'ia') {
      // Forzar la tab de Equipos (index 0)
      this.onTabChanged(0);
    }
  }
}
